import * as CustomFieldMappers from "./custom-fields-mapper";
import * as ClaimFieldMappers from "./claim-fields.mapper";

export const ClaimDataMapper = {
  CustomFieldMappers,
  ClaimFieldMappers,
};
